import { ref } from 'vue'

const pageName = ref('')

export const usePage = () => {
  return { pageName }
}